import { useEffect, useState } from "react";
import AppRoutes from "./navigation";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import {
  hostDataAtom,
  loginStatusAtom,
  modelDataAtom,
  userAtom,
} from "./atoms";
import apiAgent from "./api/apiAgent";
import { Loader } from "./components/Loader";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-toastify";
import { mergeClass, transformModelSchema } from "./utils";

const contextClass = {
  success: "bg-successGreen",
  error: "bg-warningRed",
  info: "bg-infoBlue",
  warning: "bg-warningOrange",
  default: "bg-indigo-600",
  dark: "bg-white-600 font-gray-300",
};

function App() {
  const [isValidating, setIsValidating] = useState<boolean>(true);
  const setLoginStatus = useSetAtom(loginStatusAtom);
  const setUsername = useSetAtom(userAtom);
  // const setTourPublished = useSetAtom(tourPublishAtom);
  // const setGallowsPublished = useSetAtom(gallowsPublishAtom);

  useEffect(() => {
    checkValidate();
  }, []);

  const checkValidate = async () => {
    try {
      const validateResponse = await apiAgent.Auth.validate();
      if (validateResponse.status === 200) {
        setLoginStatus(true);
        setUsername(validateResponse.data || null);
      } else {
        setLoginStatus(false);
        throw "Not logged in";
      }
    } catch (err) {
      console.log(err);
      setLoginStatus(false);
    } finally {
      setIsValidating(false);
    }
  };

  if (isValidating)
    return (
      <div className="w-full h-full grid content-center">
        <Loader />
      </div>
    );

  return (
    <>
      <AppRoutes />
      <ToastContainer
        toastClassName={(props) =>
          mergeClass(
            contextClass[props?.type || "default"],
            "relative flex p-3 rounded mb-2 overflow-hidden justify-between cursor-pointer"
          )
        }
        theme="colored"
        transition={Slide}
        position="bottom-right"
      />
    </>
  );
}

export default App;
